import { JSX, useState } from 'react';
import { Button, Form, Modal, TextArea, Message as SemanticMessage } from "semantic-ui-react";
import Message from '../../../../../../structures/message';
import Project from '../../../../../../structures/project';


interface EditMessageDialogProps {
    project: Project;
    message: Message;
    onSave: (message:Message) => void
}

export default function EditMessageDialog({project, message, onSave}:EditMessageDialogProps): JSX.Element {
    const [tempMessage, setTempMessage] = useState(message.content);
    const member = project.members.find(m => m.id == message.memberId)!;
    return <Modal
        open={true}
        size='tiny'
    >
        <Modal.Header>Редактирование сообщения</Modal.Header>
        <Modal.Content>
            <SemanticMessage>Вы редактируете сообщение от <b>{member.name} ({member.role})</b></SemanticMessage>
            <Form>
            <TextArea value={tempMessage} onChange={(e) => {setTempMessage(e.target.value)}} />
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button primary onClick={() => onSave(new Message(member.id, tempMessage, message.type))}>Сохранить</Button>
            <Button basic onClick={() => onSave(message)}>Отменить</Button>
        </Modal.Actions>
    </Modal>
}